import { CIQ_SDK_URL } from "src/components/ContinueDeal/constants";
import { ApplicationStore } from "Types/state";

export const getCIQTokenFromVin = (state: ApplicationStore) =>
    state.creditIQ?.tokenBundle?.[state.currentDeal.vin!] ?? null;

export const hasCreditIQ = (state: ApplicationStore) =>
    state?.account?.integration_settings?.Financing?.credit_iq !== undefined;

export const getCIQSdkUrl = (state: ApplicationStore) =>
    CIQ_SDK_URL[state.account.integration_settings?.Financing.credit_iq?.environment!];
